import { useEffect } from 'react';

// Gentle one-time entrance for elements marked `data-reveal` inside `rootRef`.
// Content stays fully visible without JavaScript, with reduced motion, and in print.
export default function useReveal(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (
      !root
      || !('IntersectionObserver' in window)
      || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    ) return undefined;

    const targets = [...root.querySelectorAll('[data-reveal]')];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    const revealAll = () => targets.forEach((target) => target.classList.add('is-revealed'));

    root.classList.add('dv-reveal-ready');
    targets.forEach((target) => observer.observe(target));
    window.addEventListener('beforeprint', revealAll);
    return () => {
      observer.disconnect();
      window.removeEventListener('beforeprint', revealAll);
      root.classList.remove('dv-reveal-ready');
    };
  }, [rootRef]);
}
